// extracted by mini-css-extract-plugin
module.exports = {"root":"_4306ee3a2f856f4c98249276e0db1869"};